import Client from 'modules/Client'

export default {
  fetchOne () {
    return Client.get(`api/aluno/aulaView`)
      .then(response => response.data)
  }
}